import Reflux from "reflux";
import pull from "lodash/pull";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import PaginationURL from "util/PaginationURL";
import StreamsActions from "actions/streams/StreamsActions";
import { singletonStore } from "logic/singleton";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
const StreamsStore = singletonStore(
  "Streams",
  () => Reflux.createStore({
    listenables: [StreamsActions],
    callbacks: [],
    searchPaginated(newPage, newPerPage, newQuery, additional) {
      const url = PaginationURL(
        ApiRoutes.StreamsApiController.paginated().url,
        newPage,
        newPerPage,
        newQuery,
        additional
      );
      const promise = fetch("GET", qualifyUrl(url)).then((response) => {
        const {
          elements,
          query,
          attributes,
          pagination: { count, total, page, per_page: perPage }
        } = response;
        return {
          list: elements,
          attributes,
          pagination: {
            count,
            total,
            page,
            perPage,
            query
          }
        };
      });
      StreamsActions.searchPaginated.promise(promise);
      return promise;
    },
    listStreams() {
      const url = "/streams";
      const promise = fetch("GET", qualifyUrl(url)).then((result) => result.streams).catch((errorThrown) => {
        UserNotification.error(`Loading streams failed with status: ${errorThrown}`, "Could not load streams");
        throw errorThrown;
      });
      StreamsActions.listStreams.promise(promise);
      return promise;
    },
    load(callback) {
      this.listStreams().then((streams) => {
        callback(streams);
      });
    },
    remove(streamId) {
      const url = qualifyUrl(ApiRoutes.StreamsApiController.delete(streamId).url);
      const promise = fetch("DELETE", url).then(() => CurrentUserStore.reload().then(this._emitChange.bind(this)));
      StreamsActions.remove.promise(promise);
      return promise;
    },
    pause(streamId, callback) {
      const failCallback = (errorThrown) => {
        UserNotification.error(`Pausing Stream failed with status: ${errorThrown}`, "Could not pause Stream");
      };
      const url = qualifyUrl(ApiRoutes.StreamsApiController.pause(streamId).url);
      const promise = fetch("POST", url).then(callback, failCallback).then((response) => {
        this._emitChange();
        return response;
      });
      StreamsActions.pause.promise(promise);
      return promise;
    },
    resume(streamId, callback) {
      const failCallback = (errorThrown) => {
        UserNotification.error(`Resuming Stream failed with status: ${errorThrown}`, "Could not resume Stream");
      };
      const url = qualifyUrl(ApiRoutes.StreamsApiController.resume(streamId).url);
      const promise = fetch("POST", url).then(callback, failCallback).then((response) => {
        this._emitChange();
        return response;
      });
      StreamsActions.resume.promise(promise);
      return promise;
    },
    save(stream, callback) {
      const failCallback = (errorThrown) => {
        UserNotification.error(`Saving Stream failed with status: ${errorThrown}`, "Could not save Stream");
      };
      const url = qualifyUrl(ApiRoutes.StreamsApiController.create().url);
      const promise = fetch("POST", url, stream).then(callback, failCallback).then(() => CurrentUserStore.reload().then(this._emitChange.bind(this)));
      StreamsActions.save.promise(promise);
      return promise;
    },
    update(streamId, data, callback) {
      const failCallback = (errorThrown) => {
        UserNotification.error(`Updating Stream failed with status: ${errorThrown}`, "Could not update Stream");
      };
      const url = qualifyUrl(ApiRoutes.StreamsApiController.update(streamId).url);
      const promise = fetch("PUT", url, data).then(callback, failCallback).then(this._emitChange.bind(this));
      StreamsActions.update.promise(promise);
      return promise;
    },
    cloneStream(streamId, data, callback) {
      const failCallback = (errorThrown) => {
        UserNotification.error(`Cloning Stream failed with status: ${errorThrown}`, "Could not clone Stream");
      };
      const url = qualifyUrl(ApiRoutes.StreamsApiController.cloneStream(streamId).url);
      const promise = fetch("POST", url, data).then(callback, failCallback).then(() => CurrentUserStore.reload().then(this._emitChange.bind(this)));
      StreamsActions.cloneStream.promise(promise);
      return promise;
    },
    removeOutput(streamId, outputId, callback) {
      const url = qualifyUrl(ApiRoutes.StreamOutputsApiController.delete(streamId, outputId).url);
      const promise = fetch("DELETE", url).then(callback, (errorThrown) => {
        UserNotification.error(
          `Removing output from stream failed with status: ${errorThrown}`,
          "Could not remove output from stream"
        );
      }).then(this._emitChange.bind(this));
      StreamsActions.removeOutput.promise(promise);
      return promise;
    },
    addOutput(streamId, outputId, callback) {
      const url = qualifyUrl(ApiRoutes.StreamOutputsApiController.add(streamId).url);
      const promise = fetch("POST", url, { outputs: [outputId] }).then(callback, (errorThrown) => {
        UserNotification.error(
          `Adding output to stream failed with status: ${errorThrown}`,
          "Could not add output to stream"
        );
      }).then(this._emitChange.bind(this));
      StreamsActions.addOutput.promise(promise);
      return promise;
    },
    testMatch(streamId, message, callback) {
      const url = qualifyUrl(ApiRoutes.StreamsApiController.testMatch(streamId).url);
      const promise = fetch("POST", url, message).then(callback, (error) => {
        UserNotification.error(
          `Testing stream rules of stream failed with status: ${error.message}`,
          "Could not test stream rules of stream"
        );
      });
      StreamsActions.testMatch.promise(promise);
      return promise;
    },
    onChange(callback) {
      this.callbacks.push(callback);
    },
    _emitChange() {
      this.callbacks.forEach((callback) => callback());
    },
    unregister(callback) {
      pull(this.callbacks, callback);
    }
  })
);
export { StreamsStore, StreamsActions };
export default StreamsStore;
